import Vue from "vue";
import VueRouter from "vue-router";
import RouterOptions from "vue-router";
import { routers } from "./router";
import iView from "iview";
import Util from "../lib/util";
import Cookies from "js-cookie";
import { appRouters, otherRouters } from "./router";
import store from "../store/index";

Vue.use(VueRouter);

const routerOption = {
  //mode: "history",
  routes: routers
};

export const router: VueRouter = new VueRouter(routerOption);

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  Util.title(to.meta.title);

  //     Created = 0,
  //     FreeTrial = 1,
  //     Inactive = 2,
  //     Active = 3,
  //     Incomplete = 4,
  //     IncompleteExpired = 5,
  //     PastDue = 6,
  //     Unpaid = 7,
  //     Canceled = 8,
  //     PastDueCanceled = 9

  let freeTrialExpired = false;
  let accountHasBillingIssue = false;
  let accountCanceledWithBillingIssue = false;
  let accountCanceled = false;
  let noLicenseAssigned = false;

  if (Util.abp.custom && Util.abp.custom.currentBillingAccount) {
    let account = Util.abp.custom.currentBillingAccount;
    if (account.status === 1 && account.freeTrial && account.freeTrial.endDate && new Date(account.freeTrial.endDate) < new Date()) {
      freeTrialExpired = true;
    } else if (account.status === 2 || account.status === 4 || account.status === 5 || account.status === 7) {
      accountHasBillingIssue = true;
    } else if (account.status === 8) {
      accountCanceled = true;
    } else if (account.status === 9) {
      accountCanceledWithBillingIssue = true;
    } else {
      noLicenseAssigned = account.licenseAssigned === false;
    }
  } else {
    noLicenseAssigned = true;
  }

  if (
    !Util.abp.session.userId &&
    to.name !== "test" &&
    to.name !== "login" &&
    to.name !== "signUp" &&
    to.name !== "forgot" &&
    to.name !== "reset" &&
    to.name !== "confirmEmail" &&
    to.name !== "join" &&
    to.name !== "joinproject"
  ) {
    next({
      name: "login"
    });
  } else if (Util.abp.session.userId && to.name === "login") {
    Util.title(to.meta.title);
    next({
      name: "dashboard"
    });
  } else if (Util.abp.custom && Util.abp.custom.needCompleteRegistration === true && to.name !== "login" && to.name !== "completeRegistration") {
    Util.title(to.meta.title);
    next({
      name: "completeRegistration"
    });
  } else if (
    Util.abp.session.userId &&
    (freeTrialExpired || accountCanceledWithBillingIssue || accountCanceled || noLicenseAssigned) &&
    to.name !== "createBillingAccount" &&
    to.name !== "activateaccount"
  ) {
    Util.title(to.meta.title);
    next({
      name: "activateaccount"
    });
  } else {
    const curRouterObj: any = Util.getRouterObjByName([otherRouters, ...appRouters], to.name);
    if (curRouterObj && curRouterObj.permission) {
      if (window.abp.auth.hasPermission(curRouterObj.permission)) {
        Util.toDefaultPage([otherRouters, ...appRouters], to.name, router, next);
      } else {
        next({
          replace: true,
          name: "error-403"
        });
      }
    } else {
      Util.toDefaultPage([...routers], to.name, router, next);
    }
  }
});

router.afterEach(to => {
  //Util.openNewPage(router.app, to.name, to.params, to.query);
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});
